import { create } from 'zustand';

/** Có bản mới đã tải xong và đang chờ người dùng đồng ý: `activate()` kích hoạt rồi trang tự tải lại. */
export const useSwUpdate = create<{ activate: (() => void) | null; set: (fn: (() => void) | null) => void }>((set) => ({
  activate: null,
  set: (fn) => set({ activate: fn })
}));

/** Phần tối thiểu của ServiceWorkerContainer/Registration mà logic cần (để test được). */
export interface SwContainerLike {
  register: (url: string) => Promise<RegistrationLike>;
  controller?: unknown;
  addEventListener: (type: 'controllerchange', cb: () => void) => void;
}
export interface RegistrationLike {
  waiting?: { postMessage: (m: unknown) => void } | null;
  installing?: { state: string; addEventListener: (t: 'statechange', cb: () => void) => void } | null;
  addEventListener: (type: 'updatefound', cb: () => void) => void;
  update?: () => Promise<unknown>;
}

/**
 * Đăng ký service worker và báo khi có bản mới ĐANG CHỜ (không tự chiếm trang giữa lúc đang nhập liệu).
 * Người dùng bấm "Tải lại" → gửi SKIP_WAITING → khi worker mới nắm quyền thì tải lại trang đúng một lần.
 */
export const watchSwUpdate = async (
  sw: SwContainerLike | undefined,
  onWaiting: (activate: () => void) => void,
  reload: () => void = () => window.location.reload()
): Promise<void> => {
  if (!sw) return;
  let reloading = false;
  sw.addEventListener('controllerchange', () => { if (!reloading) { reloading = true; reload(); } });
  let reg: RegistrationLike;
  try { reg = await sw.register('/sw.js'); } catch { return; }
  const announce = () => { const w = reg.waiting; if (w) onWaiting(() => w.postMessage({ type: 'SKIP_WAITING' })); };
  announce(); // bản mới đã chờ từ lần mở trước
  reg.addEventListener('updatefound', () => {
    const w = reg.installing;
    w?.addEventListener('statechange', () => { if (w.state === 'installed' && sw.controller) announce(); });
  });
};
